import { Chip, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { useMemo } from "react";
import { Prescription } from "src/api/types";
import WhiteCard from "src/components/WhiteCard";

interface Props {
  prescription: Prescription;
}

const DraftPrescription = ({ prescription }: Props) => {
  const dueDate = useMemo(() => {
    const date = prescription.metadata?.["due_date"] as string;

    return format(new Date(date), "EEE, MMM dd, yyyy");
  }, [prescription.metadata]);

  return (
    <WhiteCard sx={{ border: "1px solid #000000", borderRadius: "5px" }}>
      <Chip
        label="SCHEDULED"
        color="primary"
        sx={{ width: "fit-content", alignSelf: "end" }}
      />
      <Stack gap={1}>
        <Typography fontWeight={700}>
          🕒 Draft Prescription Scheduled
        </Typography>
        <Typography>
          A prescription for{" "}
          <span style={{ fontWeight: 700 }}>{prescription.product.name}</span>{" "}
          has been prepared will be generated on{" "}
          <span style={{ fontWeight: 700 }}>{dueDate}</span>
        </Typography>
        <Typography variant="subtitle2">
          The patient has not yet been charged and a PRESCRIPTION_REVIEW task
          for this prescription has not yet been generated.
        </Typography>
      </Stack>
    </WhiteCard>
  );
};

export default DraftPrescription;
